import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  navLinks = [
    { label: 'Why Data Unveil', fragment: 'who-we-help' },
    { label: 'Coverage', fragment: 'coverage' },
    { label: 'FAQ', fragment: 'faq' },
    { label: 'About', fragment: 'contact' }
  ];
}
